import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { postData } from '../../../../Services/Fetchnodeservices';

const VerifyDriverDocuments = ({ isDark = false }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const driver = location.state?.driver;

  const [docVer, setDocVer] = useState({});
  const [overallDocStatus, setOverallDocStatus] = useState('0');
  const [categories, setCategories] = useState({
    personalinfo: '0',
    vehicle: '0',
    bankinfo: '0',
    emergency: '0',
  });
  const [remarks, setRemarks] = useState({
    personalinfo: '',
    docinfo: '',
    vehicleinfo: '',
    bankinfo: '',
    emergencyinfo: '',
  });

  useEffect(() => {
    if (driver) {
      // Load doc_verification
      const dv = driver.doc_verification || {};
      setDocVer(dv);
      // Compute overall doc status
      const required = ['aadhaar', 'pan', 'dl'];
      const allVerified = required.every(d => dv[d]?.status === 1);
      setOverallDocStatus(allVerified ? '1' : '0');

      // Load other verification statuses
      setCategories({
        personalinfo: driver.is_verify_personalinfo || '0',
        vehicle: driver.is_verify_vehicle || '0',
        bankinfo: driver.is_verify_bankinfo || '0',
        emergency: driver.is_verify_emergency || '0',
      });
      setRemarks({
        personalinfo: driver.remarks_personalinfo || '',
        docinfo: driver.remarks_docinfo || '',
        vehicleinfo: driver.remarks_vehicleinfo || '',
        bankinfo: driver.remarks_bankinfo || '',
        emergencyinfo: driver.remarks_emergencyinfo || '',
      });
    }
  }, [driver]);

  const updateVerification = async (category, status, remark) => {
    const body = {
      driverId: driver.id,
      category,
      status: parseInt(status),
      remarks: remark || ''
    };
    const response = await postData('driver/update-verification', body);
    if (response.success) {
      // For doc-wise, update docVer and overall status
      if (['aadhaar', 'pan', 'dl', 'rc'].includes(category)) {
        const newDocVer = { ...docVer };
        if (!newDocVer[category]) newDocVer[category] = {};
        newDocVer[category].status = parseInt(status);
        newDocVer[category].remarks = remark || '';
        setDocVer(newDocVer);
        // Recompute overall doc status
        const required = ['aadhaar', 'pan', 'dl'];
        const allVerified = required.every(d => newDocVer[d]?.status === 1);
        setOverallDocStatus(allVerified ? '1' : '0');
      } else {
        // For other categories
        setCategories(prev => ({ ...prev, [category]: status }));
        const remarkField = category === 'personalinfo' ? 'personalinfo' :
                            category === 'vehicle' ? 'vehicleinfo' :
                            category === 'bankinfo' ? 'bankinfo' :
                            category === 'emergency' ? 'emergencyinfo' : '';
        if (remarkField) {
          setRemarks(prev => ({ ...prev, [remarkField]: remark || '' }));
        }
      }
    } else {
      alert(response.message || 'Update failed');
    }
  };

  const renderDocRow = (docKey, label) => {
    const doc = docVer[docKey] || { status: 0, remarks: '' };
    return (
      <div key={docKey} style={{ display: 'flex', gap: '10px', marginBottom: '12px', alignItems: 'center', flexWrap: 'wrap' }}>
        <span style={{ width: '120px', fontWeight: 600 }}>{label}</span>
        <select
          value={doc.status}
          onChange={(e) => {
            const newStatus = e.target.value;
            const newRemark = doc.remarks || '';
            updateVerification(docKey, newStatus, newRemark);
          }}
          style={{ padding: '6px 12px', borderRadius: '6px', border: '1px solid #ccc' }}
        >
          <option value="0">Pending</option>
          <option value="1">Verified</option>
          <option value="2">Rejected</option>
        </select>
        <input
          value={doc.remarks || ''}
          onChange={(e) => {
            const newDocVer = { ...docVer };
            if (!newDocVer[docKey]) newDocVer[docKey] = {};
            newDocVer[docKey].remarks = e.target.value;
            setDocVer(newDocVer);
          }}
          placeholder="Remarks"
          style={{ flex: 1, padding: '6px 12px', borderRadius: '6px', border: '1px solid #ccc' }}
        />
        <span>
          {doc.status === 1 ? '✅' : doc.status === 2 ? '❌' : '⏳'}
        </span>
        <button
          onClick={() => updateVerification(docKey, doc.status, doc.remarks || '')}
          style={{ padding: '4px 12px', background: '#4a6cf7', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer' }}
        >
          Save
        </button>
      </div>
    );
  };

  const renderCategoryRow = (catKey, label) => {
    const status = categories[catKey] || '0';
    const remarkField = catKey === 'personalinfo' ? 'personalinfo' :
                        catKey === 'vehicle' ? 'vehicleinfo' :
                        catKey === 'bankinfo' ? 'bankinfo' :
                        catKey === 'emergency' ? 'emergencyinfo' : '';
    const remarkVal = remarks[remarkField] || '';
    return (
      <div key={catKey} style={{ display: 'flex', gap: '10px', marginBottom: '12px', alignItems: 'center', flexWrap: 'wrap' }}>
        <span style={{ width: '120px', fontWeight: 600 }}>{label}</span>
        <select
          value={status}
          onChange={(e) => {
            const newStatus = e.target.value;
            setCategories(prev => ({ ...prev, [catKey]: newStatus }));
          }}
          style={{ padding: '6px 12px', borderRadius: '6px', border: '1px solid #ccc' }}
        >
          <option value="0">Pending</option>
          <option value="1">Verified</option>
          <option value="2">Rejected</option>
        </select>
        <input
          value={remarkVal}
          onChange={(e) => {
            setRemarks(prev => ({ ...prev, [remarkField]: e.target.value }));
          }}
          placeholder="Remarks"
          style={{ flex: 1, padding: '6px 12px', borderRadius: '6px', border: '1px solid #ccc' }}
        />
        <span>
          {status === '1' ? '✅' : status === '2' ? '❌' : '⏳'}
        </span>
        <button
          onClick={() => updateVerification(catKey, status, remarkVal)}
          style={{ padding: '4px 12px', background: '#4a6cf7', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer' }}
        >
          Save
        </button>
      </div>
    );
  };

  if (!driver) {
    return <div style={{ padding: '20px' }}>No driver data found. Please go back.</div>;
  }

  return (
    <div style={{ padding: '24px', maxWidth: '900px', margin: '0 auto' }}>
      <h2>Verify Driver: {driver.name}</h2>
      <hr style={{ margin: '20px 0' }} />

      <h3>📄 Documents (Aadhaar, PAN, DL)</h3>
      {renderDocRow('aadhaar', 'Aadhaar')}
      {renderDocRow('pan', 'PAN')}
      {renderDocRow('dl', 'Driving License')}
      <div style={{ marginBottom: '20px' }}>
        <strong>Overall Document Status:</strong> {overallDocStatus === '1' ? '✅ Verified' : '⏳ Pending'}
        <span style={{ marginLeft: '20px', fontSize: '14px', color: '#666' }}>
          (Auto-calculated from Aadhaar, PAN, DL)
        </span>
      </div>

      <h3>👤 Personal Information</h3>
      {renderCategoryRow('personalinfo', 'Personal Info')}

      <h3>🚗 Vehicle</h3>
      {renderCategoryRow('vehicle', 'Vehicle')}

      <h3>🏦 Bank</h3>
      {renderCategoryRow('bankinfo', 'Bank Info')}

      <h3>📞 Emergency Contact</h3>
      {renderCategoryRow('emergency', 'Emergency')}

      <div style={{ marginTop: '30px' }}>
        <button
          onClick={() => navigate(-1)}
          style={{ padding: '10px 20px', background: '#ccc', border: 'none', borderRadius: '6px', cursor: 'pointer' }}
        >
          Go Back
        </button>
      </div>
    </div>
  );
};

export default VerifyDriverDocuments;